import type { Admin, RbacPermission, RbacResource, RbacScope } from '@gozoki/api-types'
import type { Right } from '@gozoki/tools'
import { createContext } from 'react'

export interface AuthContextType {
  authenticated: boolean
  user: Admin | null
  refetchUser: () => Promise<unknown>
  isLoading: boolean
  logout: () => Promise<void>
  hasRights: (rights: Right[]) => boolean
  hasOneRight: (rights: Right[]) => boolean
  rbacEnforced: boolean
  rbacLoading: boolean
  hasResourcePermission: (resource: RbacResource, permissionType: RbacPermission) => boolean
  hasResourcePermissionScope: (
    resource: RbacResource,
    permissionType: RbacPermission,
    scope: RbacScope,
  ) => boolean
}

export const AuthContext = createContext<AuthContextType>({
  authenticated: false,
  hasRights: () => false,
  hasOneRight: () => false,
  hasResourcePermission: () => false,
  hasResourcePermissionScope: () => false,
  isLoading: false,
  rbacEnforced: false,
  rbacLoading: false,

  logout: async () => {},

  refetchUser: async () => {},
  user: null,
})
